import { type FC, Fragment } from "react";
import { Table } from "@root/shared/components/Table/legacy/Table";
import { Tr } from "@root/shared/components/Table/legacy/Tr";
import { Td } from "@root/shared/components/Table/legacy/Td";
import { Th } from "@root/shared/components/Table/legacy/Th";
import { LazyLoadImage } from "@root/shared/components/LazyLoadImage";
import { MultiLineText } from "@root/shared/components/MultiLineText";
import * as styles from "./styles.css";

type Commitment = {
  commitmentType?: string;
  commitmentText?: string;
};

type ClientContent = {
  clientName: string;
  clientImageSrc: string;
  dreamType: string;
  dreamText: string;
  commitments: Commitment[];
  ownerImageSrc?: string;
  ownerType?: string;
  ownerMessage?: string;
};

type Props = {
  site: "biyo" | "kaigo";
  canUseMessage: boolean;
  dummyImgPath: string;
  clientContent: ClientContent;
};

export const ClientCommitments: FC<Props> = ({
  site,
  canUseMessage,
  dummyImgPath,
  clientContent,
}) => (
  <section className={styles.section}>
    <h2 className={styles.sectionTitle[site]}>企業紹介</h2>
    <Table>
      <Tr>
        <Th className={styles.th}>企業画像</Th>
        <Td>
          {clientContent.clientImageSrc && (
            <figure className={styles.imageContainer}>
              <LazyLoadImage
                src={clientContent.clientImageSrc}
                alt={`${clientContent.clientName}の企業画像`}
                dummyImgPath={dummyImgPath}
                width={280}
                height={158}
              />
            </figure>
          )}
        </Td>
      </Tr>
      <Tr>
        <Th className={styles.th}>夢・想い</Th>
        <Td>
          <p className={styles.typeTitle}>{clientContent.dreamType}</p>
          <div className={styles.textByType}>
            {clientContent.dreamText && <MultiLineText text={clientContent.dreamText} />}
          </div>
        </Td>
      </Tr>
      <Tr>
        <Th className={styles.th}>こだわり・自慢</Th>
        <Td>
          {clientContent.commitments.map((item) => (
            <Fragment key={`${item.commitmentType}_${item.commitmentText}`}>
              <p className={styles.typeTitle}>{item.commitmentType}</p>
              <div className={styles.textByType}>
                {item.commitmentText && <MultiLineText text={item.commitmentText} />}
              </div>
            </Fragment>
          ))}
        </Td>
      </Tr>
      {canUseMessage && (
        <>
          <Tr>
            <Th className={styles.th}>顔写真</Th>
            <Td>
              {clientContent.ownerImageSrc && (
                <figure className={styles.ownerImageContainer}>
                  <LazyLoadImage
                    src={clientContent.ownerImageSrc}
                    alt={`${clientContent.clientName}のメッセージ画像`}
                    dummyImgPath={dummyImgPath}
                    width={158}
                    height={158}
                  />
                </figure>
              )}
            </Td>
          </Tr>
          <Tr>
            <Th className={styles.th}>{`${clientContent.ownerType}からのメッセージ`}</Th>
            <Td>
              {clientContent.ownerMessage && <MultiLineText text={clientContent.ownerMessage} />}
            </Td>
          </Tr>
        </>
      )}
    </Table>
  </section>
);
